<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { reactive, defineEmits } from 'vue';

import CardComponent from '@/components/ui/CardComponent.vue';

import type { KycComplianceFlags } from '@/types/services/user/kycComplianceFlags.type.ts';

const { t } = useI18n();

const emits = defineEmits(['closeModal']);

const props = defineProps<{
  userName: string;
  initialFlags: KycComplianceFlags;
}>();

const form = reactive<KycComplianceFlags>({ ...props.initialFlags });
</script>

<template>
  <v-form class="w-100 d-flex align-center">
    <CardComponent with-actions>
      <template #title>
        {{ t('components.editComplianceFlags.title') }}
      </template>
      <template #item>
        <p class="mb-4">
          {{ t('components.editComplianceFlags.message', { user_name: props.userName }) }}
        </p>
        <v-row dense>
          <v-col cols="12">
            <v-checkbox
              v-model="form.documentsInForeignLanguage"
              :label="t('components.editComplianceFlags.fields.documentsInForeignLanguage')"
              hide-details
            />
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="form.refusedToCommunicateInformation"
              :label="t('components.editComplianceFlags.fields.refusedToCommunicateInformation')"
              hide-details
            />
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="form.attitudeChangeDetected"
              :label="t('components.editComplianceFlags.fields.attitudeChangeDetected')"
              hide-details
            />
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="form.priorSuspiciousActivityReport"
              :label="t('components.editComplianceFlags.fields.priorSuspiciousActivityReport')"
              hide-details
            />
          </v-col>
        </v-row>
      </template>
      <template #actions>
        <div class="d-flex flex-row justify-space-between ga-4 mt-2">
          <v-btn variant="outlined" @click.prevent="emits('closeModal', false)">
            {{ t('common.buttons.cancel') }}
          </v-btn>
          <v-btn
            type="submit"
            variant="flat"
            color="primary"
            @click.prevent="emits('closeModal', form)"
          >
            {{ t('common.buttons.validate') }}
          </v-btn>
        </div>
      </template>
    </CardComponent>
  </v-form>
</template>
